export const subscriptionQueryKeys = {
  all: ['subscription'] as const,
  status: () => [...subscriptionQueryKeys.all, 'status'] as const,
};
